import { watch } from 'vue';
import useHubBrokers from './useHubBrokers';
import useHubMembers from './useHubMembers';
import useHubSegments from './useHubSegments';
import { singlePickKind } from './useResourceAccess';

export default function useAudienceNames(getAccess) {
  const { members, loadHubMembers } = useHubMembers();
  const { segments, loadHubSegments } = useHubSegments();
  const { loadHubBrokers } = useHubBrokers();
  const loaders = { member: loadHubMembers, segment: loadHubSegments, broker: loadHubBrokers };

  watch(() => singlePickKind(getAccess()), (kind) => void loaders[kind]?.(), { immediate: true });
  watch(() => (getAccess()?.broker_ids ?? []).length, (count) => { if (count) void loadHubBrokers(); }, { immediate: true });

  return { members, segments };
}
